import type {RootState} from "../store";

export const selectCourseIdInTutorHelp = (state: RootState): number => {
	return state.tutorQuestions.courseId;
};
